import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const MapSearchPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./MapSearchPage')).MapSearchPage,
  }))
);
